import { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-slate-900 text-white">載入中...</div>}>
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  )
}

export default App
